import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  addButton: {
    marginTop: theme.spacing(0.8),
  },

}));

export default useStyles;
